import script from "./cpt-page.vue?vue&type=script&setup=true&lang=js"
export * from "./cpt-page.vue?vue&type=script&setup=true&lang=js"

import "./cpt-page.vue?vue&type=style&index=0&id=2aabebf4&lang=css"

const __exports__ = script;

export default __exports__